export default __webpack_public_path__ + "static/media/logo-icpedu.aa1326d7.png";